import { useEffect } from 'react';
import { useCurrentUser } from '../../session.js';

/**
 * Aplica o tema escolhido (spec 7.4).
 *
 * `styles/tokens.css` ja tinha o bloco `:root[data-theme='dark']` desde a fase
 * 1, mas nada escrevia o atributo — o tema escuro existia no CSS e era
 * inalcancavel pela interface. Este hook fecha o circuito.
 *
 * Com `system`, o valor acompanha `prefers-color-scheme` EM TEMPO REAL: quem
 * usa o modo escuro automatico do sistema espera que o app vire junto ao
 * anoitecer, sem recarregar a pagina.
 */
export function useTheme(): void {
  const preferencia = useCurrentUser().settings.theme ?? 'system';

  useEffect(() => {
    const raiz = document.documentElement;

    if (preferencia !== 'system') {
      raiz.dataset['theme'] = preferencia;
      return;
    }

    const consulta = window.matchMedia('(prefers-color-scheme: dark)');
    const aplicar = () => {
      raiz.dataset['theme'] = consulta.matches ? 'dark' : 'light';
    };

    aplicar();
    consulta.addEventListener('change', aplicar);
    return () => consulta.removeEventListener('change', aplicar);
  }, [preferencia]);
}
